module.exports = __webpack_public_path__ + "static/P1-Sorell-232c4b58da7fc16be20f7e8ee3b2d10a.png";